import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { getfavorites } from '@helpers/helper.favorites'
import { useLocation } from '@reach/router'
// import Loading from '../Loading'
import DataTable from './dataTable'
// import DataTablePdf from './dataTable-pdf'
import toast from 'react-hot-toast'
import { Property, RealEstateDataPageComponentData, StatePropertiesSlice } from 'types'
import { useDispatch, useSelector } from 'react-redux'
import { updateFavorites } from '@slices/propertiesSlice'
import { adapt_property_data } from '@helpers/helper.mediacore'

// is_short = lite

const Tabs = ({ global_data, is_wide, is_short }: RealEstateDataPageComponentData) => {
  const favs = getfavorites('prop', 'template-site')
  const [countFavorites, setCountFavorites] = useState(favs.length)
  const location = useLocation()
  const isCompare = location.search.includes('?comparable')

  // const [isCompare, setIsCompare] = useState(false)

  const propCard = global_data.content?.cardsProperties?.type_id ?? '1'

  const Card = require(`@components/cardsProperties/${propCard}`)?.default

  const dispatch = useDispatch()

  const [elI, setElI] = useState(null)
  const [elII, setElII] = useState(null)
  const [elIII, setElIII] = useState(null)

  const { updaterFavorites } = useSelector(
    (state: { properties: StatePropertiesSlice }) => state.properties,
  )!

  const Compare = true

  const [isMounted, setIsMounted] = useState(false)

  const [listFavorites, setListFavorites] = useState(getfavorites('prop', 'template-site'))
  const [favorites, setFavorites] = useState<Property[]>([])

  const isTokko = global_data.pageConfig.keys.tokko

  useEffect(() => {
    setIsMounted(true)
    const fetchData = async (id: string) => {
      const headers: any = {}
      // Si `isTokko` es true, agrega el header 'X-TOKKO-KEY'
      if (isTokko) {
        headers['X-TOKKO-KEY'] = global_data.pageConfig.keys.tokko
      }
      try {
        const response = await axios.get(
          isTokko
            ? `https://dv-tokko.mediahaus.com.ar/api/v1/tokko/properties/${id}?cache=1`
            : `${process.env.GATSBY_APISERVER}site/propiedades/${id}/ficha/?client=${process.env.GATSBY_CLIENTID}`,
          {
            headers,
          },
        )
        // Agregamos los nuevos datos al estado usando setProperties y spread operator
        setFavorites((prevProperties) => [
          ...prevProperties,
          isTokko ? response.data : adapt_property_data(response.data),
        ])
      } catch (error) {
        console.error('Error al obtener datos:', error)
      }
    }
    if (favorites.length !== listFavorites.length) {
      setFavorites([])
      for (const id of listFavorites) {
        fetchData(id)
      }
    }
    // setIsCompare(location.search.includes('?comparar') ? true : false)
  }, [])

  const [view, setView] = useState(isCompare && !is_short ? 1 : 0)
  console.log(isCompare)
  console.log(is_short)
  console.log(view)
  // const [view, setView] = useState(1)

  useEffect(() => {
    setCountFavorites(getfavorites('prop', 'template-site').length)
    if (favorites.length !== 0) {
      if (favorites.length !== favs.length) {
        const favorites_filters = []
        for (const fav of favorites) {
          if (favs.find((id: number) => id === fav.id)) {
            favorites_filters.push(fav)
          }
        }
      }
    }
  }, [updaterFavorites])

  return (
    isMounted && (
      <section id="favorites-props">
        <div
          id="tab"
          className="p-y-config tab-container position-relative"
        >
          <div className="container-fluid">
            <div className="d-lg-flex align-items-center">
              <ul
                className={'nav nav-pills mb-4 mb-lg-3 w-100 justify-content-center'}
                id="pills-tab"
                role="tablist"
              >
                <li
                  className="nav-item mb-3 mb-lg-0 mx-2"
                  role="presentation"
                >
                  <button
                    onClick={() => setView(0)}
                    className={`btn btn-secondary border nav-link ${view === 0 ? 'active' : ''}`}
                    id="pills-favs-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-favs"
                    type="button"
                    role="tab"
                    aria-controls="pills-favs"
                    aria-selected={`${!isCompare ? 'true' : 'false'}`}
                  >
                    {favs.length} Favoritos
                  </button>
                </li>
                {!is_short && (
                  <li
                    className={'nav-item mx-2 ' + (Compare ? '' : 'd-none')}
                    role="presentation"
                  >
                    {favs.length > 1 ? (
                      <button
                        className={`btn btn-secondary border nav-link ${
                          view === 1 ? 'active' : ''
                        }`}
                        id="pills-compare-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-compare"
                        type="button"
                        role="tab"
                        aria-controls="pills-compare"
                        aria-selected={`${isCompare ? 'true' : 'false'}`}
                        onClick={() => setView(1)}
                      >
                        Comparar favoritos
                      </button>
                    ) : (
                      <button
                        onClick={() =>
                          toast.error(
                            'Tienes que tener al menos 2 propiedades en favoritos para poder comparar.',
                          )
                        }
                        className={`nav-link btn disabled-compare`}
                        id="pills-compare-tab"
                      >
                        Comparar favoritos
                      </button>
                    )}
                  </li>
                )}
              </ul>
              {/* {<DataTablePdf opacity={view === 0} />} */}
            </div>
          </div>

          <div className="container-fluid">
            <div
              className="tab-content"
              id="pills-tabContent"
            >
              <div
                className={`tab-pane fade ${!isCompare ? 'show active' : ''}`}
                id="pills-favs"
                role="tabpanel"
                aria-labelledby="pills-favs-tab"
              >
                <div className="props my-4">
                  <div className="row">
                    <div className={is_wide ? 'px-0' : 'container-fluid'}>
                      <div className="row">
                        {favorites && favorites.length > 0 ? (
                          favorites
                            .filter((fav) =>
                              favs.find((id: number) => id.toString() === fav.id.toString()),
                            )
                            .map((prop: Property, index: number) => (
                              <div
                                className={
                                  'col-md-4 mb-lg-5 mb-4 ' + (is_wide ? 'px-lg-4' : 'px-lg-5')
                                }
                              >
                                <Card
                                  global_data={global_data}
                                  key={index}
                                  basic={false}
                                  property={prop}
                                />
                              </div>
                            ))
                        ) : favs.length === 0 ? (
                          <p className="">No tienes propiedades favoritas seleccionadas.</p>
                        ) : (
                          favs.map((index: number) => (
                            <div
                              className={
                                'col-md-4 mb-lg-5 mb-4 ' + (is_wide ? 'px-lg-4' : 'px-lg-5')
                              }
                            >
                              <Card
                                global_data={global_data}
                                key={index}
                                skeleton={true}
                                basic={false}
                              />
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`tab-pane fade position-relative ${isCompare ? 'show active' : ''}`}
                id="pills-compare"
                role="tabpanel"
                aria-labelledby="pills-profile-tab"
              >
                <DataTable
                  elI={elI}
                  elII={elII}
                  elIII={elIII}
                  setElI={setElI}
                  setElII={setElII}
                  setElIII={setElIII}
                  data={favorites}
                  global_data={global_data}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  )
}

export default Tabs
